import Style from "./KeyServices.module.scss";
import KeyServiceCard from "../KeyServiceCard";
import useKeyServices from "./useKeyServices";
import KeyServiceCardSkeleton from "../KeyServiceCardSkeleton";

const KeyServices = () => {
  const { keyServicesData, status } = useKeyServices();

  return (
    <section className={Style.services_wrapper}>
      <div className="container">
        <div className={Style.services_grid}>
          {status === "loading" ? (
              Array.from({ length: 5 }).map((_, index) => (
              <KeyServiceCardSkeleton key={`skeleton-${index}`} />
            ))
          ) : keyServicesData?.services?.length > 0 ? (
            keyServicesData.services.map((service, index) => (
              <KeyServiceCard
                key={service.id || index}
                title={service.title}
                icon={service.icon}
                link={service.link}
              />
            ))
          ) : (
            <div className={Style.no_services}>No services available</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default KeyServices;
